module.exports = __webpack_public_path__ + "static/media/symbol.5148bef9.svg";